import { Grid2 } from "@mui/material";
import { useMemo } from "react";
import useUIBp from "../../../../../Hooks/useUIBoilerplate";
import { repoDataId } from "../../../../../store/actions/repositories/getRepositories";
import { humanBytes } from "../../../../../utility/misc/humanizers";
import { greylistDataId } from "../../../../UI/Specialized/Actions/getGreylist";
import { greylistPickerId } from "../../../../UI/Specialized/GreylistPicker";
import Close from "./Close";

const UIText = {
  "es-CL": { label: "Tamaño de selección: ", label2: "Gran Total: " },
  "en-US": { label: "Selection Size: ", label2: "Grand Total: " },
};

const Bottom = ({ onClose }) => {
  const { settings, warehouse, UI } = useUIBp();
  const { locale } = settings;
  const { label, label2 } = UIText[locale] ?? UIText["es-CL"];
  const greylist = warehouse[greylistDataId] ?? [];
  const repositories = warehouse[repoDataId] ?? [];
  const pickerID = UI[greylistPickerId] ?? 0;
  const selectedGreylist = greylist.filter((x) => x.milliseconds === pickerID)[0] ?? {};
  const size = selectedGreylist.size ?? 0;

  const totalSize = useMemo(() => {
    let total = 0;
    for (const repo of repositories) {
      total += repo.active_space ?? 0;
    }
    return total;
  }, [repositories]);

  return (
    <Grid2
      container
      {...{
        gap: 2,
        paddingTop: 0.5,
        sx: { width: "100%" },
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Grid2 {...{ paddingLeft: 2 }}>{!!size ? label + humanBytes(size) : null}</Grid2>
      <Grid2 {...{ paddingLeft: 2 }}>{!!totalSize ? label2 + humanBytes(totalSize) : null}</Grid2>
      <Close {...{ onClose }} />
    </Grid2>
  );
};

export default Bottom;
